import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'
import ObjectForm from '../../components/ObjectForm'

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
const typeOptions = Object.freeze([{label:"Envío", value:"Envío"}, {label:"Ajuste", value:"Ajuste"}])
const PublicityCampaignCreate = ({open, close, model, ...rest}) => {
  const app = React.useContext(AppContext)
  const { clients } = app.clients
  const AmazonSalesChannel = React.useContext(SalesChannelsContext)
  const { recall, setRecall } = AmazonSalesChannel
  const { create, update, } = AmazonSalesChannel.extraCosts

  const submit = model?update:create
  const title = model?"Actualizar":"Añadir"
  const client = model?clients.find(c => c.id == model.clientId):null
  return (
    <Dialog onClose={close} open={open}>
      <DialogTitle>{title} Costo Extra</DialogTitle>
      <ObjectForm ignored={['id']} recall={recall} submit={submit}
        stc={{ vendor: app.vendor }}
        obj={{date:'', clientId:'', cost:'', description:'', type:''}}
        labels={{date:'Fecha', clientId:'Cliente', cost:'Costo', description:'Descripcion', type: 'Tipo'}}
        types={{date:'date', clientId:'select', cost:'money', description:'text', type:'select'}}
        options={{
          clientId:clients.map(c => {return{value:c.id,label:c.name}}), 
          type:typeOptions
        }}
        controlled={{cost:model?model.cost:0, date:model?model.date:null}}
        changed={{...model, clientId:client?client.id:null} || {}} 
      />
      <Button onClick={() => {setRecall(true);close()}}>{title}</Button>
    </Dialog>
  )
}
export default PublicityCampaignCreate